import { put } from 'redux-saga/effects'
import { toast } from 'react-toastify'

import { axios as axios_user, axiosAdmin } from '../../http'
// import { logoutAction } from "../../store/sagaActions";

export default function* errorHandler({
	endpoint,
	successHandler,
	failHandler,
	payload = {},
	apiType = '',
	token = '',
	failHandlerType = '',
	customBaseURL = false,
	sendPayload = false,
	contentType = 'application/json',
}) {
	const extractErrorMessage = (errorObj) => {
		if (
			errorObj &&
			errorObj.response &&
			errorObj.response.data &&
			typeof errorObj.response.data.message === 'string' &&
			errorObj.response.data.message.trim() !== ''
		) {
			return errorObj.response.data.message
		}
		return 'Something went wrong! Please try again.'
	}
	if (apiType.trim() === '') {
		throw new Error('apiType is require')
	}
	try {
		let axios = customBaseURL ? axiosAdmin : axios_user
		let response
		if (token === '') {
			if (apiType === 'get') {
				response = yield axios.get(endpoint)
			} else if (apiType === 'post') {
				response = yield axios.post(endpoint, payload)
			} else if (apiType === 'put') {
				response = yield axios.put(endpoint, payload)
			} else if (apiType === 'delete') {
				if (sendPayload) {
					response = yield axios.delete(endpoint, { data: payload })
				} else {
					response = yield axios.delete(endpoint)
				}
			} else if (apiType === 'patch') {
				response = yield axios.patch(endpoint, payload)
			}
		} else {
			const config = {
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': contentType,
				},
			}
			if (apiType === 'get') {
				response = yield axios.get(endpoint, config)
			} else if (apiType === 'post') {
				response = yield axios.post(endpoint, payload, config)
			} else if (apiType === 'put') {
				response = yield axios.put(endpoint, payload, config)
			} else if (apiType === 'delete') {
				response = yield axios.delete(endpoint, config)
			} else if (apiType === 'patch') {
				response = yield axios.patch(endpoint, payload, config)
			}
		}
		if (response && (response.status === 200 || response.status === 201) && response.data) {
			yield successHandler(response.data)
		} else if (response !== undefined && response.status !== undefined) {
			if (
				response.data.message !== undefined &&
				response.data.message !== '' &&
				typeof response.data.message === 'string'
			) {
				yield put(failHandler(response.data.message))
			} else {
				yield put(failHandler('Server error! Please try again.'))
			}
		} else {
			yield put(failHandler('Something went wrong! Please try again.'))
		}
	} catch (error) {
		const errorMessage = extractErrorMessage(error)
		toast.error(errorMessage)
		if (
			error !== undefined &&
			error.response !== undefined &&
			error.response.status !== undefined
		) {
			const statusCode = error.response.status
			if (statusCode === 500) {
				if (failHandlerType === 'CUSTOM') {
					yield failHandler(error.response.data.message)
				} else {
					yield put(failHandler(error.response.data.message))
				}
			} else if (statusCode === 400) {
				if (failHandlerType === 'CUSTOM') {
					yield failHandler(error.response.data.message)
				} else {
					yield put(failHandler(error.response.data.message))
				}
			} else if (statusCode === 403) {
				if (failHandlerType === 'CUSTOM') {
					yield failHandler(error.response.data.message)
				} else {
					yield put(failHandler(error.response.data.message))
				}
			} else if (statusCode === 401) {
				// yield put(logoutAction({ forceLogout: true }));
			} else if (
				error.response.data &&
				error.response.data.message !== undefined &&
				error.response.data.message !== '' &&
				typeof error.response.data.message === 'string'
			) {
				if (
					error.response.data &&
					error.response.data.data &&
					error.response.data.data.type
				) {
					if (failHandlerType === 'CUSTOM') {
						yield failHandler(error.response.data.message)
					} else {
						yield put(
							failHandler({
								type: error.response.data.data.type,
								message: error.response.data.message,
							})
						)
					}
				} else if (failHandlerType === 'CUSTOM') {
					yield failHandler(error.response.data.message)
				} else {
					yield failHandler(error.response.data.message)
				}
			} else if (failHandlerType === 'CUSTOM') {
				yield failHandler('Server error! Please try again.')
			} else {
				yield put(failHandler('Server error! Please try again.'))
			}
		} else if (failHandlerType === 'CUSTOM') {
			yield failHandler('Something went wrong! Please try again.')
		} else {
			yield put(failHandler('Something went wrong! Please try again.'))
		}
	}
}
